import { useEffect, useState } from 'react';
import { PRIMARY_BAR_HEIGHT } from '../constants';

export function useHeaderBottom(
  containerId: string,
  fallback = PRIMARY_BAR_HEIGHT,
) {
  const [bottom, setBottom] = useState<number>(fallback);
  useEffect(() => {
    const compute = () => {
      const el = document.getElementById(containerId);
      if (!el) return setBottom(fallback);
      const rect = el.getBoundingClientRect();
      setBottom(Math.max(0, Math.round(rect.bottom)));
    };
    compute();
    const onScroll = () => requestAnimationFrame(compute);
    window.addEventListener('resize', compute);
    window.addEventListener('scroll', onScroll, { passive: true });

    let ro: ResizeObserver | undefined;
    const el = document.getElementById(containerId);
    if (el && 'ResizeObserver' in window) {
      ro = new ResizeObserver(compute);
      ro.observe(el);
    }
    return () => {
      window.removeEventListener('resize', compute);
      window.removeEventListener('scroll', onScroll);
      ro?.disconnect();
    };
  }, [containerId, fallback]);
  return bottom;
}
